import {GenericService, ResultType} from '@/shared/xhttp';
import {Temp} from '@/models';

export class TempService extends GenericService<Temp> {
}